import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";

const items = [
  {
    icon: <SettingsSuggestRoundedIcon />,
    title:
      "Nutq Patologiyasini Erta Aniqlash: Kichik Yoshdagi Bolalar Uchun Lingvistik Diagnostika",
    description:
      "Kichik yoshdagi bolalarda nutq patologiyasiga doir nuqsonlarni klinik amaliyotlarsiz lingvistik testlar yordamida erta tashxislash asoslari ishlab chiqiladi.",
  },
  {
    icon: <ConstructionRoundedIcon />,
    title:
      "Bolalar Til Rivojlanishidagi Psixofiziologik Nuqsonlarni Tahlil Qilish va Korrektsion Yondashuvlar",
    description: `Turli yoshli bolalarda afaziya, disleksiya, disgrafiya kabi psixofiziologik holatlar aniqlanib, o‘qish va o‘rganishdagi muammolarni hal etishning nazariy va amaliy asoslari ishlab chiqiladi.`,
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title:
      "Til Rivojlanishidagi Neyrogenezik Jarayonlar: Bilingv Bolalar Misolida Ilmiy Tahlil",
    description: `Olingan natijalar va statistik maʼlumotlarga ko‘ra, “Bilingv bolalarda leksik xilma-xillik”, “Leksika, semantika va pragmatikaning neyrolingvistik tahlili”, “Miyadagi tilning lateralizatsiyasiga genetik chapaqaylikning taʼsiri” mavzularida innovatsion loyihalar uchun ilmiy asos tayyorlanadi.`,
  },
  {
    icon: <AutoFixHighRoundedIcon />,
    title:
      "Neyrolingvistik Diagnostikani Takomillashtirish: Ilmiy Tadqiqotlar Markazi uchun Metodik Asoslar",
    description:
      "Neyrolingvistik ilmiy-o‘quv tadqiqotlar markazi faoliyatini yo‘lga qo‘yish uchun zamonaviy neyropsixolingvistik tashxislash metodikasi yaratiladi",
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title:
      "Tilni Idrok Etish va Muloqot Qobiliyatida Qiyinchiliklar Bor Bolalar Uchun Nutqiy Profilaktika Loyihasi",
    description:
      "Ushbu loyiha nutqida nuqsoni aniqlangan, o‘qish va yozishda tilni idrok etishda o‘ziga xos muammosi bor, atrofdagilar bilan muloqot kompitentligi shakllanmagan turli yoshdagi bolalarda nutqiy komplekslar paydo bo‘lishining oldini olishga xizmat qiladi. Mazkur loyihadan kutilayotgan natijalar maktab yoshigacha bo‘lgan bolalar va boshlang‘ich sinf o‘quvchilari, ota-onalar, izlanuvchilar, tarbiyachilar, maktab o‘qituvchilaridan iborat minglab isteʼmolchilar uchun zarurdir.",
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: "white",
        bgcolor: "grey.900",
      }}
    >
      <Container
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: "100%", md: "60%" },
            textAlign: { sm: "left", md: "center" },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Qisqacha
          </Typography>
          <Typography variant="body1" sx={{ color: "grey.400" }}>
            Bizning loyiha orqali insonlar nimalarga erishadi?
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: "inherit",
                  p: 3,
                  height: "100%",
                  borderColor: "hsla(220, 25%, 25%, 0.3)",
                  backgroundColor: "grey.800",
                }}
              >
                {/* <Box sx={{ opacity: "50%" }}>{item.icon}</Box> */}
                <div>
                  <Typography gutterBottom sx={{ fontWeight: "medium" }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "grey.400" }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
